interface ModalNavigationProps {
  onChange: (index: number) => void;
  index: number;
}

export const ModalNavigation = ({ onChange, index }: ModalNavigationProps) => {
  const handlePrev = () => {
    if (index > 0) {
      onChange(index - 1);
    }
  };

  const handleNext = () => {
    if (index < 4) {
      onChange(index + 1);
    }
  };

  return (
    <div className='logo-arrows'>
      <div className='modal-arrows'>
        <img
          src={`https://${import.meta.env.VITE_MEDIA_HOST}/left-arrow.svg`}
          className={index === 0 ? 'disabled' : ''}
          onClick={handlePrev}
        />
        <img
          src={`https://${import.meta.env.VITE_MEDIA_HOST}/right-arrow.svg`}
          className={index === 4 ? 'disabled' : ''}
          onClick={handleNext}
        />
      </div>
    </div>
  );
};
